import { errorCodeKey } from '~/helpers/api/error-code'

/** Refus de l'API qui ont leur propre message ; les autres reçoivent le message générique. */
const KEYS: Record<string, string> = {
  ALREADY_SUBSCRIBED: 'billing.offers.error.subscribed',
  CHECKOUT_IMPERSONATION: 'billing.offers.error.impersonation',
  STRIPE_DISABLED: 'billing.offers.error.unavailable',
  STRIPE_PRICE_MISSING: 'billing.offers.error.unavailable',
  BILLING_SELF_SERVICE_DISABLED: 'billing.offers.error.unavailable',
  BILLING_MANAGED: 'billing.offers.error.managed',
  NO_STRIPE_CUSTOMER: 'billing.offers.error.noCustomer',
}

/**
 * Le texte à montrer quand la page de paiement ou le portail client ne s'ouvre
 * pas (#352, #353) : un refus définitif ne doit pas inviter à réessayer en boucle.
 */
export function checkoutErrorKey(error: unknown): string {
  return errorCodeKey(error, KEYS, 'billing.offers.error')
}
